import { h } from "vue";
import { ElNotification } from 'element-plus'
import "./index.scss";
import NotificationIcon from "./NotificationIcon.vue";



export default {
  install(app) {
    const nfFunc = ({title, message, type, ...rest}) => {
      const options = {
        title,
        message,
        customClass: 'dispatch-notify-' + type,
        ...rest,
        zIndex: 9999,
        icon: {
          render: () => h(NotificationIcon, {
            type, // success | warning | info | error
          })
        }
      }
      return ElNotification(options);
    }
  
    // 对外提供派发通知的方法
    app.config.globalProperties.dispatchNotify = nfFunc;
    app.provide('dispatchNotify', nfFunc);
    if (window) {
      window.dispatchNotify = nfFunc;
    }
  }
};

